import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import errorAction from '../../../actions/error';
import './error-modal.css';

const Modal: React.FC = () => {
    const error = useSelector((state: any) => state.error);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    function onCancel() {
        dispatch(errorAction.clearError());
        if (error.onClose && typeof error.onClose === 'function') {
            error.onClose();
        }
    }

    if (!error.code) return null;
    return (
        <>
            <div className="error-modal__mask" />
            <div className="error-modal__container">
                <div className="error-modal">
                    <div className="error-modal__title">{error.title}</div>
                    <div className="error-modal__description">{error.description}</div>
                    <button
                        className="error-modal__button error-modal__button--large error-modal__button--block"
                        data-testid="cancel-modal-button"
                        onClick={onCancel}
                    >
                        {t('common.ok')}
                    </button>
                </div>
            </div>
        </>
    );
};

export default Modal;
